import { K8sProvider } from '@cast/shared-types';

export const PROVIDERS_WITHOUT_FEATURE_SELECTION: K8sProvider[] = [
  K8sProvider.ANYWHERE,
  K8sProvider.ROSA,
];
